export class Translations {
    public static REFRESH_CART_MESSAGE = 'Please note: The items in your current shopping bag can only be purchased in this country. Changing your shopping country will also refresh your shopping bag.';
    public static COOKIE_USAGE_MESSAGE = 'We use cookies. By closing this message or continuing to browse the site, you are agreeing the application to use the cookies. For more information on our cookie policy';
}
